module.exports = __webpack_public_path__ + "static/media/hot33.75b99366.jpg";